export default __webpack_public_path__ + "static/media/message-empty.15121cdb.svg";